@if (popupState() === 'warning') {
  <div class="session-overlay" role="dialog" aria-modal="true" aria-labelledby="warning-title">
    <div class="session-dialog session-warning">
      <div class="session-icon warning">
        <i class="bi bi-clock-history"></i>
      </div>
      <h3 class="session-title" id="warning-title">Session Expiring</h3>
      <p class="session-message">Your session will expire in about 1 minute. Would you like to continue?</p>
      <div class="session-actions">
        <button class="btn-session-secondary" (click)="onDismissWarning()">Cancel</button>
        <button class="btn-session-primary" [disabled]="refreshing()" (click)="onKeepSession()">
          @if (refreshing()) {
            <span class="spinner-border spinner-border-sm me-1" role="status"></span>
          }
          Yes, Keep Session
        </button>
      </div>
    </div>
  </div>
}

@if (popupState() === 'expired') {
  <div class="session-overlay" role="dialog" aria-modal="true" aria-labelledby="expired-title">
    <div class="session-dialog session-expired">
      <div class="session-icon danger">
        <i class="bi bi-exclamation-circle-fill"></i>
      </div>
      <h3 class="session-title" id="expired-title">Session Expired</h3>
      <p class="session-message">Your session has expired. You will be redirected to login.</p>
      <p class="session-countdown">Redirecting in <strong>{{ countdown() }}</strong> seconds&hellip;</p>
      <div class="session-actions">
        <button class="btn-session-primary" (click)="onExpiredOk()">OK</button>
      </div>
    </div>
  </div>
}
